'use es6';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { VALID_RSS_STATUS_TYPES } from 'EmailData/utils/constants';
import { fetchBlogEmails, resetBlogEmails, resetRssFeedUrlValidation } from 'EmailData/actions';
import { getAvailableBlogEmailTypes, getBlogEmails, getBlogEmailsErrored, getBlogEmailsLoading } from 'EmailData/selectors/blogEmailSelectors';
import { getRssFeedUrlValidationResult } from 'EmailData/selectors/rssFeedUrlValidationSelectors';
import ContentRoutes from 'ContentUtils/Routes';
import EmailCreationModal from 'EmailComponents/emailCreation/EmailCreationModal';
import EmailTemplateModesForParams from 'EmailData/enums/EmailTemplateModesForParams';
import { CREATION_STEPS, EMAIL_CREATION_TYPES } from 'EmailData/constants/emailCreation';
import { getCanSelectMoreThanRegularEmail, getEmailTypesAuthedFor, getShouldUseBUPicker, hasAccessToBusinessUnit } from 'EmailData/selectors/user';
import { navigateTo } from 'EmailComponents/utils/urlUtils';
import { trackDashboardInteraction } from 'EmailComponents/utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, props) => {
  const canSelectEmailType = props.canChangeEmailType && getCanSelectMoreThanRegularEmail(state);
  const rssFeedValidationResult = getRssFeedUrlValidationResult(state);
  const status = rssFeedValidationResult.get('feedResultStatus') || 'REQUIRED';
  const validRssUrl = VALID_RSS_STATUS_TYPES.includes(status) ? rssFeedValidationResult.get('feedUrl') : '';
  return {
    availableEmailTypes: getEmailTypesAuthedFor(state),
    canAccessBusinessUnit: hasAccessToBusinessUnit(state),
    validRssUrl,
    availableBlogTypes: getAvailableBlogEmailTypes(state),
    blogEmailError: getBlogEmailsErrored(state),
    canSelectEmailType,
    canSelectMoreThanRegularEmail: getCanSelectMoreThanRegularEmail(state),
    blogEmails: getBlogEmails(state),
    blogEmailLoading: getBlogEmailsLoading(state),
    selectedTeamIds: props.selectedTeamIds,
    shouldUseBUPicker: getShouldUseBUPicker(state)
  };
};
class EmailCreationModalContainer extends Component {
  constructor(props) {
    super(props);
    this.navigate = (href, params = {}) => {
      const {
        external
      } = this.props;
      if (!Object.keys(params).length) {
        navigateTo(href, external);
        return;
      }
      const base = href.includes('?') ? `${href}&` : `${href}?`;
      const paramString = Object.keys(params).map(key => {
        if (key === 'teamIds' && Array.isArray(params[key])) {
          return params[key].map(id => `${key}=${id}`).join('&');
        }
        return `${key}=${params[key]}`;
      }).join('&');
      navigateTo(`${base}${paramString}`, this.props.external);
    };
    this.onNextStep = (step, otherState = {}) => {
      this.setState(Object.assign({
        currentCreationStep: step,
        stepIndex: this.state.stepIndex + 1
      }, otherState));
    };
    this.onClickBack = () => {
      if (this.state.currentCreationStep === CREATION_STEPS.BLOG_RSS_FEED_SELECT) {
        if (this.state.selectedBlog === -1) {
          trackDashboardInteraction({
            otherActions: `clicked-back-from-create-rss`
          });
          this.props.resetRssFeedUrlValidation();
        } else {
          trackDashboardInteraction({
            otherActions: `clicked-back-from-create-blog`
          });
          this.props.resetBlogEmails();
        }
        this.setState({
          currentCreationStep: CREATION_STEPS.EMAIL_TYPE,
          stepIndex: this.state.stepIndex - 1
        });
      }
    };
    this.onClickCreate = () => {
      if (this.state.selectedEmailType === EMAIL_CREATION_TYPES.BLOG_RSS) {
        this.onNextStep(CREATION_STEPS.BLOG_RSS_FEED_SELECT);
      } else if (this.props.isTemplateEditor) {
        this.props.createEmailFromTemplate({
          businessUnitId: this.state.businessUnitId,
          selectedEmailType: this.state.selectedEmailType
        });
      } else {
        this.handleCreateAction(this.state.selectedEmailType);
      }
    };
    this.onSelectEmailType = type => {
      if (type === EMAIL_CREATION_TYPES.BLOG_RSS) {
        trackDashboardInteraction({
          otherActions: 'clicked-create-blog-rss'
        });
      }
      this.setState({
        selectedEmailType: type
      });
    };
    this.onSelectRssFeedUrl = url => {
      // initiate validation of url
      this.setState({
        rssFeedUrl: url,
        selectedBlog: -1,
        canContinue: true
      });
    };
    this.onSelectBlog = blog => {
      // selecting rss feed
      if (blog === -1) {
        this.setState({
          selectedBlog: -1,
          blogEmails: [],
          selectedFrequency: null,
          canContinue: false
        });
        this.props.resetBlogEmails();
      } else {
        this.setState({
          rssFeedUrl: '',
          selectedBlog: blog,
          selectedFrequency: null,
          canContinue: false
        });
        // selecting hubspot blogs
        if (blog === null) {
          this.props.resetRssFeedUrlValidation();
          // selected a blog
        } else {
          this.props.fetchBlogEmails(blog);
        }
      }
    };
    this.onSelectBusinessUnit = buId => {
      if (![undefined, null, ''].includes(buId)) {
        this.setState({
          businessUnitId: buId
        });
      }
    };
    this.onSelectFrequency = frequency => {
      this.setState({
        selectedFrequency: frequency,
        canContinue: this.state.selectedBlog !== -1
      });
    };
    this.onConfirm = () => {
      this.handleCreateAction(this.state.selectedTemplateMode);
    };
    this.state = {
      currentCreationStep: CREATION_STEPS.EMAIL_TYPE,
      rssFeedUrl: '',
      rssFeedUrlIsValid: false,
      selectedBlog: null,
      selectedFrequency: null,
      selectedEmailType: '',
      selectedTemplateMode: null,
      stepIndex: 0,
      canContinue: false,
      businessUnitId: 0
    };
  }
  static getDerivedStateFromProps(nextProps, state) {
    if (nextProps.blogEmailError) {
      return {
        canContinue: false
      };
    }
    return {
      canContinue: state.canContinue
    };
  }
  createAction(emailType) {
    const {
      mergedHref,
      availableBlogTypes,
      blogEmails,
      canAccessBusinessUnit,
      selectedTeamIds
    } = this.props;
    const {
      currentCreationStep,
      rssFeedUrl,
      selectedBlog,
      selectedFrequency,
      businessUnitId
    } = this.state;
    const href = mergedHref;
    const urlParams = {
      subcategory: EmailTemplateModesForParams.DRAG_DROP_EMAIL
    };
    if (selectedTeamIds.length > 0) {
      urlParams.teamIds = selectedTeamIds;
    }
    if (canAccessBusinessUnit) {
      urlParams.businessUnitId = businessUnitId;
    }
    switch (currentCreationStep) {
      case CREATION_STEPS.TEMPLATE_TYPE:
        this.navigate(href, urlParams);
        break;
      case CREATION_STEPS.EMAIL_TYPE:
        trackDashboardInteraction({
          otherActions: `selected-create-with-email-type-${emailType}`
        });
        this.navigate(href, Object.assign({}, urlParams, {
          emailType
        }));
        break;
      case CREATION_STEPS.BLOG_RSS_FEED_SELECT:
        if (rssFeedUrl) {
          trackDashboardInteraction({
            otherActions: `selected-create-with-email-type-rss`
          });
          this.navigate(href, Object.assign({}, urlParams, {
            emailType: EMAIL_CREATION_TYPES.BLOG_RSS,
            rssUrl: encodeURIComponent(rssFeedUrl)
          }));
        } else {
          if (availableBlogTypes.indexOf(selectedFrequency) > -1) {
            trackDashboardInteraction({
              otherActions: `selected-create-with-email-type-blog`
            });
            this.navigate(href, Object.assign({}, urlParams, {
              emailType: EMAIL_CREATION_TYPES.BLOG_RSS,
              blogId: selectedBlog,
              blogEmailType: selectedFrequency
            }));
          } else {
            trackDashboardInteraction({
              otherActions: `selected-edit-with-email-type-blog`
            });
            const email = blogEmails.find(e => e.blogEmailType === selectedFrequency);
            this.navigate(ContentRoutes.edit(email.id, 2));
          }
        }
        break;
      default:
        break;
    }
  }
  handleCreateAction(emailType) {
    const {
      isTemplateEditor
    } = this.props;
    if (isTemplateEditor) {
      const {
        rssFeedUrl,
        selectedBlog,
        selectedFrequency,
        businessUnitId
      } = this.state;
      this.props.createEmailFromTemplate({
        businessUnitId,
        selectedEmailType: emailType,
        rssFeedUrl,
        selectedBlog,
        selectedFrequency
      });
      return;
    }
    this.createAction(emailType);
  }
  render() {
    const {
      onClose,
      validRssUrl,
      availableBlogTypes,
      shouldUseBUPicker,
      availableEmailTypes,
      canAccessBusinessUnit,
      emailBusinessUnitId
    } = this.props;
    return /*#__PURE__*/_jsx(EmailCreationModal, Object.assign({
      availableBlogTypes: availableBlogTypes,
      availableEmailTypes: availableEmailTypes,
      canAccessBusinessUnit: canAccessBusinessUnit,
      emailBusinessUnitId: emailBusinessUnitId,
      onClickBack: this.onClickBack,
      onClickCreate: this.onClickCreate,
      onClose: onClose,
      onConfirm: this.onConfirm,
      onSelectBlog: this.onSelectBlog,
      onSelectBusinessUnit: this.onSelectBusinessUnit,
      onSelectEmailType: this.onSelectEmailType,
      onSelectFrequency: this.onSelectFrequency,
      onSelectRssFeedUrl: this.onSelectRssFeedUrl,
      shouldUseBUPicker: shouldUseBUPicker,
      validRssUrl: validRssUrl
    }, this.state));
  }
}
EmailCreationModalContainer.propTypes = {
  availableBlogTypes: PropTypes.array,
  availableEmailTypes: PropTypes.array.isRequired,
  blogEmailError: PropTypes.bool,
  blogEmails: PropTypes.object,
  canAccessBusinessUnit: PropTypes.bool,
  canSelectEmailType: PropTypes.bool,
  canSelectMoreThanRegularEmail: PropTypes.bool,
  emailBusinessUnitId: PropTypes.number,
  external: PropTypes.bool,
  fetchBlogEmails: PropTypes.func,
  mergedHref: PropTypes.string,
  onClose: PropTypes.func,
  resetBlogEmails: PropTypes.func,
  resetRssFeedUrlValidation: PropTypes.func,
  shouldUseBUPicker: PropTypes.bool,
  validRssUrl: PropTypes.string,
  isTemplateEditor: PropTypes.bool,
  createEmailFromTemplate: PropTypes.func,
  selectedTeamIds: PropTypes.arrayOf(PropTypes.number)
};
export default connect(mapStateToProps, {
  fetchBlogEmails,
  resetRssFeedUrlValidation,
  resetBlogEmails
})(EmailCreationModalContainer);